// @flow
import React, { memo } from "react";
import t from "common/i18n";
import RadioGroup from "root/components/RadioGroup";

type Props = {
    value: string,
    withPeopleOnly: boolean,
    className?: string,
    onChange: Function,
};

const GENDER_OPTIONS = ["female", "male", "both"]
	.map((value) => ({ value, label: t(`shutterstock.filters.gender.${value}`) }));

const Gender = (props: Props) => (<section className={props.className}>
	<label>{t("shutterstock.filters.gender.label")}</label>
	<RadioGroup
		options={GENDER_OPTIONS}
		disabled={!props.withPeopleOnly}
		showAsBoxes
		onChange={(newValue) => props.onChange({ gender: newValue })}
		className="flex-shrink-0"
		value={props.value}/>
</section>);

export default memo<Props>(Gender);
